import { useContext, useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import styled from "styled-components";
import { ProductContext } from "../../context/ProductContext";
import { cartActions } from "../../store/cart-slice";
import { calculatePrice } from "../../utils/discount";
import ImageSlider from "../../components/product/ImageSlider";
import AddToCartAnim from "../../components/animations/AddToCartAnim";
import { useNavigation } from "../../utils/navigation";
import { useTranslation } from "react-i18next";
import Breadcrumbs from "../../components/section/BreadCrumbs";
import ProductDetails from "../../components/section/ProductDetails";
import descriptions from "../../descriptions.json";

const Container = styled.main`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  background-color: var(--bg-100);

  padding-top: calc(var(--navbar-height) + var(--navbar-mini));
  min-height: 90vh;
  @media (min-width: 768px) {
    padding-top: calc(var(--navbar-height-desktop) + var(--navbar-mini));
  }
`;
const BreadcrumbsContainer = styled.div`
  @media (min-width: 1025px) {
    padding: var(--spacing-xxl) 0 0 0;
    max-width: var(--max-width-container);
  }
  width: 94%;
`;
const TitleContainerDesktop = styled.div`
  display: none;
  @media (min-width: 1025px) {
    display: block;
    max-width: var(--max-width-container);
  }
  width: 94%;
`;
const TitleContainerMobile = styled.div`
  width: 94%;
  @media (min-width: 1025px) {
    display: none;
  }
  display: flex;
  justify-content: center;
  margin-top: 40px;
`;
const SpecificationDesktop = styled.div`
  width: 100%;
  display: none;
  @media (min-width: 1025px) {
    display: block;
  }
`;
const SpecificationMobile = styled.div`
  width: 100%;
  @media (min-width: 1025px) {
    display: none;
  }
`;
const Wrapper = styled.div`
  padding-bottom: var(--spacing-xxl);
  width: 94%;

  @media (min-width: 768px) {
    width: 100%;
  }
  @media (min-width: 1025px) {
    max-width: var(--max-width-container);
    display: flex;
    position: relative; /* Ovo je potrebno za relativno pozicioniranje unutar roditelja */
    justify-content: flex-end;
  }
`;

const LeftContainer = styled.div`
  @media (min-width: 1025px) {
    width: 70%;
    position: sticky;
    right: calc(
      (100vw - var(--max-width-container)) / 2 + var(--max-width-container) -
        700px
    );
    top: calc(var(--navbar-height-desktop) + var(--font-size-xxlarge) + 40px);
  }
`;

const RightContainer = styled.div`
  display: flex;
  flex-direction: column;
  @media (min-width: 1025px) {
    width: calc(100% - 70% - 20px);
  }
`;
const Title = styled.h1`
  font-size: var(--font-size-xlarge);
  width: 100%;
  font-weight: 500;
  text-align: center;

  @media (min-width: 768px) {
    padding: 0 0 var(--spacing-xl) 0;
    text-align: left;
    font-size: var(--font-size-xxlarge);
  }
`;
const FlexDiv = styled.div`
  display: flex;
  gap: var(--spacing-md);
`;
const FlexDivIcons = styled(FlexDiv)`
  gap: var(--spacing-md);
  flex-direction: column;
`;

const FlexDivPrice = styled(FlexDiv)`
  margin: var(--spacing-md) 0;
  justify-content: space-between;
  gap: 20px;

  @media (min-width: 768px) {
    width: 50%;
  }
`;

const Price = styled.span`
  font-size: var(--font-size-xlarge);
  font-weight: bold;
`;

const BrT = styled.div`
  height: 1px;
  background-color: var(--text-color);
  width: 100%;
  margin: var(--spacing-lg) 0;
  opacity: 0.1;
`;

const GridQuantity = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);

  gap: 10px;
  align-items: stretch;
  justify-content: flex-start;
  margin-top: 14px;
  @media (min-width: 768px) {
    grid-template-columns: repeat(4, 1fr);
  }
`;
const GridQuantityItem = styled.div`
  box-sizing: border-box;
  font-family: "Gudea-Regural";
  cursor: pointer;
  color: ${({ $isActive }) =>
    $isActive ? "var(--accent-100)" : "var(--text-200)"};
  border: 2px solid;
  border-color: ${({ $isActive }) =>
    $isActive ? "var(--accent-100)" : "var(--bg-300)"};
  background-color: ${({ $isActive }) =>
    $isActive ? "var(--bg-100)" : "var(--bg-200)"};
  text-align: center;
  width: 100%;
  padding: 10px 4px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  transition: border-color 0.15s ease-in-out, transform 0.1s ease-in-out;
  &:hover {
    border-color: var(--accent-100);
  }
  &:active {
    transform: scale(0.97);
  }
  box-shadow: var(--shadow-medium);
  border-radius: 12px;
`;
const QuantityLabel = styled.span`
  font-size: var(--font-size-base);
  font-weight: 700;
`;
const QuantityPiecePrice = styled.span`
  font-size: var(--font-size-small);
  color: var(--text-200);
`;
const QuantityBadge = styled.span`
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  background-color: var(--success-color);
  color: var(--bg-100);
  padding: 1px 6px;
  border-radius: 8px;
`;

const ButtonContainer = styled.div`
  @media (min-width: 768px) {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    gap: 4px;
  }
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: var(--spacing-sm);
  //padding: var(--spacing-xl) 0;
`;

const ButtonWrapper = styled.div`
  position: relative; /* Roditeljski kontejner koji omogućava apsolutno pozicioniranje za decu */
  display: inline-block; /* Omogućava kontejneru da se prilagodi veličini sadržaja */
  width: 100%;
  text-align: center;
`;

const Button = styled.button`
  width: 100%;
  background-color: var(--primary-200);
  color: var(--bg-200);

  font-size: var(--font-size-large);
  font-weight: 600;
  padding: var(--spacing-sm) var(--spacing-lg);
  transition: background-color 0.15s ease, color 0.15s ease, transform 0.1s ease;

  &:hover {
    background-color: var(--bg-200);
    color: var(--primary-100);
  }
  &:active {
    transform: scale(0.98);
  }
  &:disabled {
    background-color: var(--bg-300);
    border-color: var(--bg-300);
    color: var(--text-100);
    cursor: not-allowed;
  }
`;

const IconDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
`;
const SVGIcon = styled.svg`
  box-sizing: content-box;
  background-color: rgba(86, 147, 191, 0.1);
  padding: 10px;
  border-radius: 50%;
  min-width: 32px;
  min-height: 32px;
  flex-shrink: 0;
`;
const IconText = styled.span`
  font-size: var(--font-size-base);
  color: var(--p-color);
  padding: 0;
  margin: 0;
`;

const DescTitle = styled.h2`
  text-transform: uppercase;
  font-weight: 300;
`;
const DescText = styled.p`
  font-weight: 200;
`;

const StatusDot = styled.div`
  width: 14px;
  height: 14px;
  border-radius: 50px;
  background-color: ${({ status }) =>
    status === "in_stock"
      ? "var(--success-color)"
      : status === "on_request"
      ? "var(--warning-color)"
      : "var(--error-color)"};
`;

const GridIcons = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 14px;
  margin-bottom: 14px;

  order: 3;
  @media (min-width: 768px) {
    margin-top: 14px;
    order: 0;
  }
`;
const GridIconsItem = styled.div`
  box-sizing: border-box;
  background-color: var(--bg-200);
  border: 1px solid transparent;
  border-radius: 12px;
  padding: 14px 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 4px;
  text-align: center;
  transition: border-color 0.2s ease, box-shadow 0.2s ease,
    transform 0.2s ease;

  &:hover {
    border-color: var(--accent-200);
    box-shadow: var(--shadow-large, 0 4px 12px rgba(0, 0, 0, 0.08));
    transform: translateY(-2px);
  }

  h3 {
    margin: 2px 0 0;
    font-size: var(--font-size-small);
  }
`;
const TextIconsP = styled.p`
  font-size: var(--font-size-small);
  color: var(--p-color);
  padding: 0;
  margin: 0;
`;

const StickyBar = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 40;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--spacing-md);
  background-color: var(--bg-100);
  border-top: 1px solid var(--bg-300);
  box-shadow: 0 -4px 16px rgba(0, 0, 0, 0.08);
  padding: 10px 16px calc(10px + env(safe-area-inset-bottom, 0px)) 16px;
  transform: translateY(${({ $visible }) => ($visible ? "0" : "100%")});
  transition: transform 0.25s ease;

  @media (min-width: 1025px) {
    display: none;
  }
`;
const StickyBarPrice = styled.div`
  display: flex;
  flex-direction: column;
  line-height: 1.2;
`;
const StickyBarButton = styled.button`
  flex-shrink: 0;
  background-color: var(--primary-200);
  color: var(--bg-200);
  font-size: var(--font-size-base);
  font-weight: 600;
  padding: 12px 20px;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  transition: background-color 0.15s ease, transform 0.1s ease;

  &:active {
    transform: scale(0.98);
  }
  &:disabled {
    background-color: var(--bg-300);
    color: var(--text-100);
    cursor: not-allowed;
  }
`;

const ProductMain = () => {
  const { t, i18n } = useTranslation();
  const { slug } = useParams();

  const [selectedQuantity, setSelectedQuantity] = useState(10);
  const dispatch = useDispatch();
  const {
    setIsCartOpen,

    loadProductBySlug,
    product,
    setProduct,
    currencyTag,
    loadRecommededProductsBySlug,
  } = useContext(ProductContext);
  const [discountedPrice, setDiscountedPrice] = useState(0);
  const [savingsPercentage, setSavingsPercentage] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);
  const [breadcrumbItems, setBreadcrumbItems] = useState([]);
  const [showStickyBar, setShowStickyBar] = useState(false);
  const buyBoxRef = useRef(null);

  useEffect(() => {
    if (!buyBoxRef.current) {
      return;
    }
    const observer = new IntersectionObserver(
      ([entry]) => setShowStickyBar(!entry.isIntersecting),
      { threshold: 0 }
    );
    observer.observe(buyBoxRef.current);
    return () => observer.disconnect();
  }, [product]);

  useEffect(() => {
    if (!slug) {
      return;
    }
    setProduct(null);
    const fetchProduct = async () => {
      try {
        const productData = await loadProductBySlug(slug); // Pretpostavljamo da loadProductBySlug vraća podatke o proizvodu
        setProduct(productData);
        window.scrollTo(0, 0);
      } catch (error) {
        console.error("Failed to load product:", error);
        // Ovde možete postaviti neki state za grešku ako želite da obavestite korisnika
      }
    };

    fetchProduct();
    loadRecommededProductsBySlug(slug);
  }, [slug, i18n.language]);
  useEffect(() => {
    if (product) {
      const newDiscountedPrice = calculatePrice(
        product.price,
        selectedQuantity
      );
      setDiscountedPrice(newDiscountedPrice);

      const newSavingsPercentage = Math.round(
        ((product.price - newDiscountedPrice) / product.price) * 100
      );
      setSavingsPercentage(newSavingsPercentage);
      setBreadcrumbItems([
        { name: "SnusCo", url: "/" },
        { name: "Nicotine Pouches", url: `/${i18n.language}/snus-verkauf` },
        {
          name: ` ${product.name}`,
          url: "/",
        },
      ]);
    }
  }, [product, selectedQuantity]);

  const addToCart = (selectedQuantity) => {
    dispatch(
      cartActions.addToCart({
        product: product,
        quantity: selectedQuantity,
      })
    );
    setIsCartOpen(true);
    setIsAnimating(true);
  };

  const handleAnimationComplete = () => {
    setIsAnimating(false);
  };
  const getDiscountData = (quantity) => {
    const discountedPrice = calculatePrice(product.price, quantity);
    const savings = Math.round(
      ((product.price - discountedPrice) / product.price) * 100
    );
    return { discountedPrice, savings };
  };

  const [shortDesc, setShortDesc] = useState("");

  useEffect(() => {
    // Pronađi objekat za trenutni slug
    const item = descriptions.find((d) => d.slug === slug) ?? null;
    if (!item) {
      setShortDesc(t("loading"));
      return;
    }

    // Odredi jezik i ključ
    const lang = i18n.language.startsWith("sr")
      ? "sr"
      : i18n.language.startsWith("de")
      ? "de"
      : "en";
    const shortKey = `short_${lang}`;

    // Učitaj kratki opis
    setShortDesc(item[shortKey] || "");
  }, [slug, descriptions, i18n.language, t]);

  return (
    <Container>
      {product && (
        <>
          <BreadcrumbsContainer>
            <Breadcrumbs breadcrumbs={breadcrumbItems} />
          </BreadcrumbsContainer>
          <TitleContainerDesktop>
            <Title>
              {product.name} {product.format} ({product.pouches_per_can}{" "}
              {t("PRODUCT.POUCHES_PER_CAN")}) {product.nicotine}MG{" "}
              {t("PRODUCT.NICOTINE")}
            </Title>
          </TitleContainerDesktop>
          <Wrapper>
            <LeftContainer>
              <div style={{ position: "relative" }}>
                <ImageSlider
                  images={product.images}
                  productName={product.name}
                />
              </div>
              <TitleContainerMobile>
                <Title>{product.name}</Title>
              </TitleContainerMobile>
              <SpecificationDesktop>
                <ProductDetails product={product} />
              </SpecificationDesktop>
            </LeftContainer>
            <RightContainer>
              <FlexDiv
                style={{
                  gap: "4px",
                  marginBottom: "14",
                  alignItems: "center",
                  justifyContent: "flex-end",
                }}
              >
                <StatusDot status={product.is_in_stock} />
                <h5>
                  {product.is_in_stock
                    .split("_")
                    .map((word) => word[0].toUpperCase() + word.slice(1))
                    .join(" ")}
                </h5>
              </FlexDiv>
              <GridIcons>
                <GridIconsItem>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    id="Layer_1"
                    data-name="Layer 1"
                    viewBox="30.72 57.54 245.35 184.88"
                    class="w-12 h-12 hover:text-black"
                    width="60"
                    height="60"
                    fill="var(--accent-200)"
                  >
                    <defs></defs>
                    <polygon
                      class="cls-1"
                      points="96.74 224.05 96.75 224.04 96.73 224.04 96.74 224.05"
                    ></polygon>
                    <path
                      class="cls-1"
                      d="M272.68,205.31c-1.94-3.11-4.45-5.72-7.09-8.23-.66-.63-.99-1.07.3-1.29,1.04-.18,2.03-.6,3.07-.76,1.11-.17,1.2-.65.77-1.54-.83-1.69-2.27-2.82-3.65-3.99-2.02-1.72-4.1-3.35-6.19-5.05.95-.43,1.81.21,2.85,0-2.4-3.98-5.55-7-9.45-9.25.1-.6.19-1.19.29-1.79.68-.47,1.47-.54,2.25-.64.26-.03.53-.09.61-.35.08-.27-.16-.45-.35-.6-.73-.6-1.47-1.19-2.21-1.78-3.78-2.31-8.06-3.28-12.39-4.52,1.43-1.39,3.26-1.67,4.88-2.71-4.17-3.75-9.41-3.83-14.55-4.77,1.39-1.06,2.94-1.51,4.5-2.35-4.59-3.54-9.79-4.11-15.45-3.78.84-1.74,1.93-3,3.07-4.24.39-.42,1.21-.77.97-1.39-.22-.57-1.04-.42-1.64-.49-4.58-.59-9.17-.2-13.76-.3-.49-.01-.97,0-1.72,0,.71-.83,1.24-1.45,1.76-2.06-.32-.64-1.04-.06-1.4-.71,1.76-1.99,3.3-4.21,4.49-6.66.88-1.81.89-1.8-1.18-1.77,0,0-.05-.06-.05-.06,2.04-2.1,4.03-4.21,4.85-7.17.79-2.85.62-3.26-2.27-3.82-.58-.11-1.16-.19-1.8-.29.52-1.22,1.03-2.37,1.5-3.52.32-.77.08-1.05-.75-.79-.9.28-1.81.53-3.09.9,2.98-3.85,6.02-7.26,6.71-12.09-1.38.26-2.35,1.32-3.94,1.69,1.9-3.82,2.74-7.64,2.64-11.66-.62-.33-.75.59-1.39.46.56-2.23,1.52-4.35,1.92-6.63.05-.3.15-.59.18-.88.08-.87.14-1.91-.52-2.41-.59-.45-1.2.51-1.84.74-.65.24-1.26.59-2.18,1.03.99-3.48,1.39-6.75,1.24-10.07q-.84-3.25-4.23-3.08c-.1,0-.2,0-.3,0-2.92,1.3-5.61,2.92-7.76,5.36-.61.69-1.16,2.19-1.87,1.91-1.08-.41.21-1.69-.12-2.59-.02-.05-.04-.09-.15-.34-4.07,1.9-7.74,4.35-10.99,7.87-.05-.96-.09-1.62-.14-2.5-3.6,2.76-6.29,6.14-9.13,9.49-.45-.66.04-1.49-.48-2.22-3.02,3.04-5.98,6.03-7.65,10.13-.79-.82-.34-1.95-1.09-2.8-2.68,2.96-5.01,6.15-6.83,9.72-.65-.29-.36-1.15-1.06-1.48-2.09,1.97-3.42,4.73-6.04,6.35-.4-4.78-2.11-9.16-3.88-13.59-.68.5-.79,1.25-1.18,1.82-.2.29-.39.69-.76.68-.56-.02-.51-.62-.54-.95-.38-3.89-2.02-7.36-3.55-10.87-.26-.59-.44-1.24-1.06-1.7-.67.5-.53,1.51-1.39,2.09-1.72-4.8-3.86-9.37-6.5-13.91-.35,1.17-.64,2.15-1.04,3.52-2.11-5.5-5.41-9.67-9.49-13.55-.18.95-.33,1.72-.47,2.48-.08.44-.33.74-.78.81-.55.08-.6-.32-.76-.72-.66-1.68-1.38-3.34-2.07-5.01-1.98-2.86-4.24-5.43-7.39-7.08-.13-.07-.14-.34-.21-.52h-1.82c-.87,1.85-2.07,3.52-2.64,5.53-.65,2.32-1.06,4.68-1.31,7.07-.05.48,0,1.02-.65,1.2-.56.16-1.07.19-1.49-.34-.31-.39-.77-.68-1.03-1.1-.83-1.39-1.24-.75-1.79.24-.76,1.36-.37,2.98-1.12,4.32.68.96.23,2.05.3,3.07.08,1.33.02,2.67.02,4.12-.86-.44-.79-1.32-1.43-1.81-1.86,4.52-1.99,9.16-1.16,14.02-1.4-.52-2.19-1.48-2.94-2.53-.2-.29-.46-.79-.94-.55-.36.18-.18.64-.21.97-.28,4.04,1.04,7.75,2.36,11.45.34.94.64,1.89.96,2.84-1.58-.29-2.54-1.72-4.14-2.3-.23,1.66-.13,3.21.36,4.73.84,2.63,1.93,5.16,3.27,7.58.26.47.59.93.51,1.51-1.13-.73-2.27-1.45-3.54-2.27-.04,5.73,2.57,10.34,5.87,14.92-2.39-.1-4.34-.73-6.48-1.09,1.52,3.72,3.91,6.73,6.06,10.22-4.26.17-8.37-.12-12.62.86,1.74,2.1,3.64,3.91,4.91,6.52-6.17-.26-12.08-.05-17.23,3.93,1.55,1.28,3.67,1.53,5.25,2.93-5.83,1.02-11.87,1.02-16.82,5.17,1.92,1.07,3.98,1.66,5.83,3.14-1.56.42-2.9.81-4.25,1.14-3.84.94-7.42,2.53-10.93,4.29-.36,1.01-1.6,1.27-1.96,2.25.67.62,1.68.21,2.31.85,1.31-.18,2.37.4,3.65,1.16-1.31.41-2.07,1.44-3.33,1.45-2.39,1.85-4.79,3.68-6.79,5.97-1.04,1.18-2.03,2.39-2.82,4.06,1.27-.27,2.23-.34,3.49-.18-3.25,2.58-6.31,4.93-9.19,7.5-.99.88-1.86,1.82-2.43,3.03-.42.89-.27,1.36.82,1.55,1.43.26,2.82.73,4.23,1.09.69.18.89.44.23.95-1.73,1.33-3.22,2.92-4.67,4.53-2.58,2.85-4.82,5.94-6.07,9.66-.38,1.13-.13,1.73.83,2.38,5.29,3.58,10.94,3.58,16.8,1.85.54-.16,1.26-.8,1.64-.23.46.69.37,1.65-.01,2.46-.15.31-.45.54-.7.79-.7.67-.81,1.12.35,1.38,4.72,1.05,9.47,1.24,14.25.53.76-.11,1.71-.93,2.22-.27.62.8-.38,1.51-.86,2.19-.19.27-.53.59-.32.94.22.36.63.15.97.1,3.07-.48,6.15-.95,9.23-1.43,2.15-.64,4.3-1.29,6.56-1.96.09,1.03-.7,1.58-1,2.34-.12.32-.5.63-.3.96.21.35.63.15.97.09,4.81-.92,9.6-1.88,13.72-4.79.65-.46.86-.12.95.54.17,1.29-.81,2.25-.92,3.46,2.91-.22,5.54-1.41,8.25-2.33,1.96-.66,3.8-1.62,5.6-2.65.28-.16.58-.61.89-.25.18.21.15.67.11,1.01-.2,1.83-.19,1.9,1.57,1.49,3.87-.89,7.53-2.27,10.69-4.78.39-.31.81-.57,1.34-.93.1,1.81-1.05,3.13-1.33,4.97,6.89-4.1,13.12-8.67,19.24-13.91.01,2.62.81,4.75,1.61,7.05.39-.5.68-.87,1.23-1.57-.23,3.1.12,5.73,1.69,8.22.37-.59.68-1.09,1.23-1.97.57,3.4.9,6.55,2.9,9.17.61-.64.54-1.54,1.01-2.19.59.15.56.68.75,1.05,1.16,2.29,2.36,4.54,4.68,5.9.46.27.55.83.8,1.26.35.61.71,1.22,1.06,1.83.47.83,1.23,1.58,2.08,1.56.71-.02.47-1.18.83-1.77.08-.13.17-.24.38-.55,1.15,1.59,2.14,3.19,3.51,4.5,2.73,2.6,3.72,2.46,5.35-1.02.49-1.05.89-2.14,1-3.31.1-1.09.25-2.17.38-3.28.58-.05.6.62,1,.79.7-.24,1.99-5.3,2.35-9.22.71-.05.67.82,1.3,1,.34-3.09.59-6.16.27-9.27.56-.3.68.5,1.27.44.16-2.66.17-5.33-.52-8.39,4.73,3.59,9.19,6.94,14.13,9.71-.05-1.5-1.18-2.63-1.1-4.08,0,0,.02-.02.02-.02,1.93,1.07,3.65,2.48,5.77,3.24,1.57.57,3.15,1.08,4.77,1.45,1.58.36,1.67.28,1.36-1.28-.07-.34-.16-.69.08-1.12,3.61,2.18,7.56,3.53,11.61,4.62.45.12,1.05.53,1.42.17.44-.42-.18-.9-.29-1.36-.04-.15-.1-.29-.15-.43-.21-.57-.6-1.29-.13-1.7.49-.43.96.33,1.4.58,3.88,2.19,8.12,3.1,12.53,3.77-.17-1.19-1-1.91-1.33-3.13,2.14.66,4.12,1.27,6.11,1.89,3,.08,5.91,1.13,9.14,1.12-.34-.55-.51-.85-.71-1.14-.2-.29-.43-.56-.65-.84-.24-.3-.35-.66-.15-.99.21-.35.53-.09.81-.02,4.08,1.07,8.18.81,12.28.12.79-.13,1.9-.08,2.28-.57.75-.97-.73-1.25-1.04-1.96-.25-.59-.33-1.26-.07-1.76.33-.62.91-.05,1.33.08,3.43,1.02,6.85,1.44,10.4.52,1.99-.51,3.66-1.61,5.46-2.47v-2.73c-.87-.95-1.19-2.2-1.85-3.27ZM212.44,125.87c.78-.15,1.33.31.87,1.32-1.02,2.28-2.63,4.04-4.65,5.46-1.47,1.03-1.66,1.81-.37,3.13.82.84.64,1.41.07,2.19-1.15,1.61-2.35,3.17-4.14,4.12-.68.36-.69.79-.4,1.35.57,1.09.11,1.79-.66,2.63-2.3,2.51-4.81,4.42-8.56,4.24,1.22.73,2.43,1.45,3.85,2.3-2,1.15-3.37,3.23-6.02,2.32-.53-.18-.72.17-.49.71.2.46.27,1,.55,1.4,1.05,1.52.22,2.25-1.04,2.99-1.34.79-2.55,1.83-4.29,1.53-.89-.16-.81.36-.64,1,.69,2.61.67,2.6-1.69,3.8-1.25.63-2.51.93-3.92.68-1.09-.2-1.5.09-.86,1.26.98,1.79.93,1.86-.95,2.55-1.89.7-3.72,1.56-5.69,2.03-.62.15-1.02.1-1.49-.32-3.17-2.83-6.71-5.16-10.38-7.29-.49-.29-.93-.62-1.27-1.06-1.91-2.46-4.35-4.33-6.81-6.17-.96-.72-1.14-1.33-.68-2.47,2.94-7.18,6.65-13.91,11.45-20.03.34-.43.74-.8,1.17-1.27.19.32.33.52.44.74.45.88,1.14,1.87,1.94,2.01,1.06.19.96-1.27,1.47-1.94.77-1,1.4-2.09,2.24-3.04.63-.72.83-.29.97.26.21.87.33,1.77.56,3.06,2.2-2.71,4.14-5.23,6.7-7.4.21,1.23.27,2.37.91,3.5,1.94-1.89,3.77-3.76,5.88-5.31.79-.59,1.15-.96,1.27.45.15,1.79.51,1.91,1.99.83,1.28-.93,2.67-1.62,4.07-2.31.83-.41,1.28-.26,1.17.73-.14,1.22.49,1.06,1.25.77,1.88-.73,3.76-1.45,5.64-2.18,1-.38,1.45-.27,1.09.98-.23.8-.2,1.68.03,2.64,2.08-.73,4.1-1.49,6.23-1.88,1.05-.19,2.1-.13,3.15-.33ZM143.86,178.03c-3,1.47-6.29,2.12-9.54,2.82-.59.13-.78-.06-.98-.58-.25-.68-.11-1.4-.27-2.07-.64-.09-.97.35-1.33.68-1.33,1.21-3.03,1.25-4.67,1.47-.99.13-1.08-.62-1.25-1.35-.25-1.03-.3-2.16-1.95-.95-.91.67-2.4.66-3.64.72-.86.04-1.84-.18-1.69-1.53.04-.37-.19-.77-.31-1.16-.23-.75-.6-1.08-1.23-.34-1.13,1.34-2.67.96-4.1.97-.82,0-.72-.5-.46-1.03.43-.88.86-1.76,1.49-3.05-.98.51-1.57.76-2.09,1.1-2.49,1.63-5.06.68-7.61.26-.61-.1-.59-.66-.71-1.05-.25-.86-.46-1.31-1.63-1.14-1.83.26-3.54-.59-5.2-1.32-.55-.24-.44-.63-.38-1.12.22-1.84-.17-2.17-2-2.36-2.04-.22-4.1-.42-5.89-1.66-.83-.57-.77-.88,0-1.37,2.08-1.31,4.37-2.12,6.74-2.6,1.51-.3,1.32-.85.6-1.74-.22-.27-.45-.55-.7-.79-.54-.54-.41-.83.3-.99,1.67-.37,3.33-.74,4.99-1.15.75-.18,1.96-.11.87-1.46-.44-.55.01-.86.51-.91,1.44-.16,2.88-.61,4.35-.21,1.25.35,1.53-.11,1.05-1.2-.54-1.21-.06-1.53,1.08-1.36,1.69.24,3.41.36,5.06.75,1.46.35,1.47-.16,1.06-1.25-.16-.42-.21-.87-.31-1.31,0,0,.01-.01.01-.01,2.27-.02,4.33.86,6.45,1.48.4.12.86.56,1.26.16.41-.41-.08-.84-.16-1.26-.1-.48-.28-.95-.49-1.6,1.78.17,3.24.83,4.59,1.65,1.06.65,1.27.37,1.58-.68.21-.71-.42-1.83.62-2.11.76-.2,1.51.43,2.27.68,8.71,2.86,16.17,7.91,23.34,13.43,1.19.92,2.25,2.01,3.38,3.02.43.38.61.74.16,1.27-3.9,4.61-7.57,9.5-13.18,12.24ZM154.82,122.45c.73.45,1.59,1.46,2.35.99.69-.43-.05-1.6.03-2.41.25-2.53,1.44-4.69,2.92-6.71.26-.35.54-.41.91-.23.32.15.63.33.97.43.67.2,1.47.65,2.02.45.82-.3-.03-1.1.05-1.72.2-1.58,1.11-2.8,1.91-4.07.58-.94,1.09-2.12,1.96-2.63.92-.54,1.88.65,2.89.92,1.66.44,1.65.51,1.48-1.21-.21-2.07,1.05-3.55,2.14-5.03,1.79-2.42,1.18-2.35,2.79.16.49.76.91,1.55,1.38,2.35.56-.33.38-.8.33-1.12-.44-2.97,1.04-5.13,2.89-7.15.58-.63,1.13-1.29,1.68-1.95,1.01-1.21,2.03-2.28,3.78-1.14.65.42,1.15.25,1.54-.55,1.35-2.74,3.84-4.34,6.27-5.98.48-.32.87-.33,1.32.13.45.46,1.01.85,1.58,1.16,1.06.57,1.81.54,2.56-.74,1.81-3.13,4.39-5.48,7.85-6.79,1.13-.43,1.54-.21,1.54,1.05,0,3.77-.66,7.4-1.99,10.93-.18.48-.69,1.04-.23,1.53.37.39.95.11,1.44,0,.63-.15,1.28-.27,1.92-.34.47-.05,1.02-.66,1.37-.15.2.3-.03.96-.19,1.42-.93,2.66-1.91,5.32-2.86,7.97-.29.8-.6,1.48.86,1.09,1.43-.38,1.79.1,1.29,1.51-.72,2.06-1.69,4-3.02,5.74q-1.24,1.62.8,2.08c.39.09.78.2,1.18.22.33.02.64-.33,1.07-.05-1.78,2.89-3.94,5.51-6.37,7.8-1.1,1.03-3.01,1.3-4.68,1.44h0s0,0,0,0c-.1-.79-.69-.59-1.16-.54-2.54.28-5.1.52-7.45,1.65-.07.03-.19-.02-.28-.03-.04-.09-.12-.18-.11-.26.11-.74,1.13-1.51.65-2.02-.54-.58-1.45.22-2.19.42-2.54.7-4.45,2.48-6.76,4.15.2-1.01.35-1.75.52-2.62-3.15.61-5.3,2.68-7.48,4.68.05-.53.09-1.06.14-1.69-3.67,1-6.08,3.59-8.52,6.51-.16-1.06-.29-1.96-.43-2.86-.05-.33.12-.81-.33-.89-.21-.04-.51.27-.72.46-1.93,1.8-3.38,4-5.01,6.05-4.37,5.49-7.6,11.63-10.45,18.18-.72-.97-.67-1.99-.9-2.92-.73-2.88-1.17-5.83-1.33-8.78-.16-3.08.67-6.09,1.49-9.05.88-3.16,1.99-6.24,3.18-9.29.31-.79.58-1.1,1.47-.54ZM100.15,134.66c1.49-.18,2.9-.04,4.21-.58,1.7-.7,1.81-1.08.53-2.4-2.44-2.53-4.23-5.49-5.9-9.08,1.8.81,3.25,1.45,4.85,1.55.4.03.88.25,1.16-.04.37-.4-.17-.71-.35-1.02-2.05-3.36-3.97-6.8-5.64-10.37-.25-.53-.59-1.04-.51-1.8,1.27.37,2.45.96,3.75,1.07.45.04.96.28,1.29-.07.44-.46.03-.95-.18-1.39-1.86-3.75-3.36-7.65-4.56-11.84,1.26.34,2.38.68,3.51.93,1.01.22,1.53.03,1.08-1.21-1.1-3.01-1.53-6.14-1.49-9.34,0-.95.15-1.35,1.17-.79,2.59,1.43,2.34.67,2.11-1.53-.33-3.18-.15-6.35-.22-9.53-.01-.44-.22-1.02.19-1.28.5-.32.74.34,1.1.56,1.07.65,2.08,1.39,3.28,1.86,1,.39,1.2.21,1.19-.81-.06-3.22-.12-6.45.61-9.63.32-1.43.73-2.82,1.27-4.19.42-1.05.83-1.39,1.91-.57,2.84,2.15,4.66,4.99,5.94,8.23.22.56.32,1.18.6,1.71.42.79-.06,2.23.9,2.39,1.11.19,2.49.1,3.49-.65,1.05-.8,1.48-.32,2.11.51,2.1,2.78,4.31,5.49,4.74,9.12.1.86.79.73,1.28.64,1.99-.38,3.06.47,3.68,2.33.56,1.67,1.32,3.27,2.03,4.89.95,2.16,1.23,4.34.38,6.61-.15.41-.08.9-.1,1.35-.04.01-.08.02-.11.04-.02.01-.02.05-.02.08.04-.04.09-.08.13-.12,1.41-1.05,2.74-2.2,4.14-3.69,1.2,3.54,3,6.73,1.29,10.41-.36.78.05.85.65.85,1.21.01,2.42.03,3.6-.34.38-.12.75-.35.96.27.97,2.87,2.04,5.72,1.79,8.82-.21,2.56-.87,5-1.85,7.39-2.01,4.86-3.5,9.88-4.12,15.11-.39,3.29.37,6.51.98,9.72.31,1.62.67,3.23,1.03,4.97-1.07-.18-1.7-.95-2.5-1.39-1.77-.97-3.41-2.23-5.27-2.96-2.53-.99-3.47-3.08-4.32-5.3-2.6-6.78-4.58-13.76-6.4-20.79-2.28-8.76-4.43-17.55-6.15-26.45-.06-.29-.2-.56-.64-.78,1.04,5.56,2.09,11.11,3.12,16.67,1.04,5.64,2.24,11.24,3.5,16.83,1.26,5.59,2.76,11.12,4.69,16.83-2.11-.72-3.99-1.36-5.87-2.01-1.48-.51-2.95-1.02-4.49-1.31-.34-.07-.76-.25-.95.11-.1.18.1.56.21.83.23.6.7,1.11.73,1.82-.69.3-1.32-.08-1.88-.27-2.24-.76-4.48-.43-6.73-.16-.25.03-.65.09-.54.35.65,1.64-.78.81-1.07.78-.95-.12-1.97-.49-2.84-.15-1.71.67-2.59,0-3.49-1.38-2.01-3.08-4.17-6.06-6.25-9.1-.25-.36-.41-.79-.68-1.34ZM142.63,189.47c-1.1,4.59-2.01,9.24-2.18,13.98-.05,1.28-.43,2.23-1.4,3.02-3.48,2.83-7.03,5.56-10.91,8.06-.74-1.73-.96-3.6-1.96-5.2-.53.29-.75.74-.95,1.18-1.94,4.19-5.78,5.84-9.75,7.34-.77.29-1.09.02-1.22-.77-.1-.58-.32-1.2-.66-1.68-.49-.69-.65-1.93-1.46-2-.81-.07-.81,1.21-1.29,1.81-1.22,1.51-2.96,2.26-4.66,3.02-1.56.7-3.19,1.24-4.79,1.88-.64.25-.94.22-1.11-.59-.34-1.64-1.13-3.11-2.02-4.54-.45-.72-.78-.72-1.12.04-1.93,4.38-6.24,4.86-10.07,6.11-.85.28-.58-.32-.52-.77.28-2.09.54-4.18.85-6.62-.54.59-.93.9-1.15,1.29-1.49,2.64-3.79,4.05-6.7,4.72-2.65.61-5.28,1.27-7.97,1.65-.64.09-.93.05-1.07-.59-.06-.29-.18-.58-.29-.86-.93-2.34-1.21-2.47-3.4-1.42-1.16.55-2.4.88-3.64.92-2.57.08-5.14.25-7.7-.23-.61-.11-.8-.17-.74-.91.14-1.75-.58-3.34-1.28-4.91-.34-.76-.82-.52-1.36-.28-3.08,1.34-6.23,2.3-9.65,2.14-2.2-.1-4.26-.59-6.25-1.56-.92-.45-1.02-.95-.62-1.76,1.25-2.5,2.81-4.79,4.7-6.83,2.2-2.36,4.47-4.67,7.12-6.55.94-.67.78-1.23-.04-1.86-1.35-1.03-2.92-1.6-4.51-2.08-.96-.29-1.02-.61-.26-1.23,3.56-2.89,7.1-5.81,10.85-8.45,1.44-1.02,1.42-1.07.02-2.2-.59-.47-1.79-.42-1.72-1.36.05-.72,1.05-1.01,1.61-1.51,2.68-2.38,5.78-4.05,9.14-5.22,1.04-.36,1.05-.66.51-1.54-.91-1.49-2.42-2.21-3.91-3.22,3.37-1.68,6.83-2.57,10.29-3.46,1.56-.4,3.15-.65,4.73-.96.9-.17,1.22-.51.65-1.42-.88-1.42-2.14-2.39-3.51-3.26-.32-.2-.88-.26-.76-.79.09-.39.58-.37.89-.45,3.21-.88,6.5-1.32,9.81-1.61,1.75-.16,3.5-.47,5.27-.34.95.07.83-.41.49-1.02-1.14-2.03-3.07-3.14-5.19-4.4,1.75-.93,3.49-1.13,5.18-1.2,2.86-.12,5.75-.27,8.58.5.96.26,1.29-.19,1.19-1.11-.23-2.08-1.23-3.81-2.39-5.48-.2-.3-.7-.59-.42-1.03.21-.33.65-.18.99-.18,2.27-.01,4.55,0,6.82,0,.52,0,1.03,0,1.37.47.98,1.39,1.95,2.79,2.98,4.28-2.16.42-4.22.56-6.14,1.49.52.72,1.46.75,2.14,1.5-2.14.54-4.42.84-5.92,2.34-1.71,1.71-4.07,1.86-5.9,3.15-1.35.95-1.38,1.08-.02,1.88.99.58.7.9-.11,1.26-1.85.82-3.64,1.7-5.15,3.11-1.05.98-.99,1.83-.09,2.8,1.87,1.99,4.21,3.06,6.87,3.52.19.03.37.08.64.14-.11.6-.73.57-1.02,1.07,2.48,1.73,5.19,2.96,8.14,3.74,0,.65-.82.48-1.02,1.04,2.82.9,5.72,1.42,8.8,1.97-.78.68-.96,1.04.22,1.27,2.43.48,4.84.94,7.37.9-4.26,1.36-8.63,2.27-12.85,3.71-4.35,1.48-8.66,3.04-12.86,4.9-4.13,1.83-8.2,3.76-11.92,6.39,1.35-.61,2.72-1.18,4.06-1.82,10.41-5.04,21.4-8.28,32.72-10.5,1.43-.28,2.88-.59,4.32-.62,1.5-.03,3-.46,4.47.79.82.69,2.4.51,3.64.65.8.09,1.61.03,2.41.04-.33.43-.66.85-1.12,1.45,6.12-.37,11.75-2.32,17.51-3.58,0,0,0,0,0,0-.93,2.9-1.98,5.65-2.66,8.5ZM176.01,197.35c.84.52,1.97,4.45,1.7,5.31-.11.37-.41.37-.69.47-.47.17-.92.41-1.4.57-1.12.4-1.37.88-.29,1.69,1.26.95,1.41,2.37,1.52,3.8.06.77-.32,1-1.02.8-.91-.25-1.75-.72-2.92-.78.14.35.16.53.25.61,2.55,2.15,2.68,5.11,2.77,8.1.03.84-.12,1.45-1.08,1.69-.97.24-1.13.86-.87,1.86.45,1.79.05,3.6-.27,5.39-.12.67-.63.76-1.24.83-1.93.24-2.18.63-2.01,2.49.18,2.05.3,4.11-.39,6.1-.16.46-.25,1.11-.77,1.22-.55.12-.82-.49-1.13-.87-1.63-2.01-2.93-4.24-3.91-6.63-.36-.89-.62-.83-1.22-.24-.61.61-1.09,1.31-1.7,2.23-1.1-2.08-1.95-4.09-2.72-6.13-.34-.9-.67-1.52-1.56-.42-.54.67-.84.16-1.06-.34-.55-1.25-.92-2.55-1.02-3.93-.04-.63-.25-1.25-.41-2-.88.47-1.66.89-2.46,1.32-.5-2.37-.49-4.68-.44-6.99.03-1.26-.28-1.64-1.41-.79-.43.32-.95.52-1.54.84-.35-2.99.33-5.83.53-8.8-1.31.38-2.09,1.32-3.28,1.81.26-1.9.36-3.73,1.07-5.45.43-1.03.2-1.52-.98-1.35-.15.02-.31.04-.45,0-.72-.22-1.56.88-2.02.13-.3-.5.11-1.45.21-2.19.95-6.78,3.04-13.23,5.74-19.5.29-.67.74-1.18,1.25-1.69,2.78-2.79,5.72-5.42,8.06-8.62.34-.46.69-.68,1.27-.32,3.56,2.21,7.17,4.32,10.2,7.27,3.35,3.27,4.89,7.59,6.73,11.73.25.55.1.94-.6,1.07-.63.12-1.23.39-2.04.66,1.27,1.4,2.66,2.49,3.1,4.33.49,2.08.56,2.23-1.31,3.16-.91.46-1.39.77-.18,1.52ZM268.91,210.95c-3.59,1.17-7.17.56-10.62-.8-2.64-1.04-2.63-1.07-3.49,1.68-.12.38-.33.81-.26,1.17.36,1.91-.86,2.21-2.26,2.24-3.27.07-6.6.38-9.57-1.49-.84-.53-1.23.14-1.34.63-.62,2.72-2.36,2.7-4.55,2.12-2.14-.57-4.3-1.04-6.41-1.73-2.07-.68-2.93-2.52-4.2-3.99-.21-.25-.24-.7-.83-.73.23,2,.43,3.98.72,5.94.1.68-.02.85-.67.66-2.18-.64-4.29-1.43-6.28-2.56-1.45-.82-1.75-2.4-2.68-3.67-1.14,1.35-1.86,2.78-2.29,4.34-.25.92-.61,1.27-1.6.86-1.86-.79-3.78-1.42-5.56-2.39-1.17-.64-2.22-1.39-2.71-2.72-.34-.93-.77-1.13-1.36-.15-.52.86-1.14,1.69-1.34,2.7-.16.8-.57.89-1.27.64-3.97-1.44-7.42-3.48-9.03-7.87-1.03,1.29-1.28,2.65-1.63,3.92-.26.97-.55,1.05-1.27.52-2.35-1.74-4.7-3.48-7.05-5.21-.5-.36-.68-.89-.77-1.43-.25-1.43-.45-2.88-.64-4.32-.1-.8,1-.99.9-2-.16-1.6-.2-3.21-.54-4.79-.08-.38-.27-.93.42-.76,1.34.34.92-.39.71-1.04-1.64-4.94-3.54-9.78-6.3-14.22-.57-.92-.23-1.04.53-1.48,3.49-2.02,6.94-.78,10.38,0,13.21,3.01,26.34,6.37,39.15,10.83,4.72,1.64,9.4,3.37,13.89,5.59.39.19.76.48,1.28.24-17.83-8.99-36.88-14.52-56.14-19.73.49-.69,1.18-.79,1.72-1.1.52-.3,1.06-.56,1.66-.87-.66-.45-1.34-.5-2.26-.59,2.29-1.4,4.35-2.67,5.97-4.5.19-.21.73-.45.52-.63-1.58-1.34.4-1.31.71-1.52,1.82-1.27,3.49-2.74,5.23-4.11.48-.38.97-.86-.18-.99-.24-.03-.56.02-.61-.31-.05-.37.28-.49.54-.64,2.48-1.52,4.43-3.64,6.47-5.75-.41-.49-1-.09-1.37-.35,1.24-1.81,2.89-2.51,5.14-2.39,3.53.18,7.08.04,10.61.05.37,0,.88-.22,1.08.26.16.36-.26.62-.44.91-.86,1.37-1.71,2.73-1.84,4.42-.09,1.14.23,1.54,1.45,1.27,3.49-.76,7-.68,10.48.12.29.07.56.2,1.03.36-1.71,1.11-3.24,2.19-4.32,3.8-.72,1.07-.35,1.27.71,1.28,4.3,0,8.53.58,12.71,1.51.4.09.79.15,1.17.54-1.48.91-2.74,2.02-3.81,3.37-.79,1-.34,1.36.64,1.51,3.1.46,6.11,1.28,9.09,2.2,1.28.4,2.53.92,4,1.47-1.38,1.02-2.59,1.82-3.42,3.05-.48.71-.69,1.02.44,1.36,3.73,1.12,6.96,3.14,9.69,5.89-.06.16-.06.28-.12.32-3.01,1.78-2.99,1.75-.2,3.85,2.65,2,5.25,4.08,7.87,6.12,1,.78.95,1.29-.35,1.62-1.24.31-2.34.93-3.37,1.68-.79.57-1.08.99-.04,1.75,3.83,2.78,7.1,6.11,9.61,10.16,1.57,2.53,1.72,2.85-1.56,3.91Z"
                    ></path>
                    <path
                      class="cls-1"
                      d="M96.74,224.05s0,0,0,0c-.02.04-.04.09-.06.13l.07-.12Z"
                    ></path>
                    <path
                      class="cls-1"
                      d="M76.42,194.94s.09-.1.14-.14c-.05.04-.1.09-.15.13,0,0,.01.01.01.01Z"
                    ></path>
                    <path
                      class="cls-1"
                      d="M196.61,134.56c-2.27,1.21-4.63,2.27-6.79,3.64-9.1,5.76-17.55,12.33-24.85,20.27-.97,1.06-2.07,2.04-2.71,3.38l.06.05c.37.02.69-.07.98-.32,3.8-3.29,7.65-6.53,11.39-9.88,3.22-2.88,6.47-5.74,9.86-8.42,4.27-3.38,8.83-6.3,13.55-9l-.02-.02c-.52-.04-1,.06-1.46.3Z"
                    ></path>
                    <path
                      class="cls-1"
                      d="M164.47,217.68c.87-15.17-1.65-30.12-2.98-45.13.83,15.06.18,30.22,2.98,45.13Z"
                    ></path>
                    <path
                      class="cls-1"
                      d="M107.9,163.92c2.66-.2,5.25-.53,7.86-.54,4.94-.03,9.89,0,14.82.33,2.46.17,4.91.39,7.36.65,4.86.51,9.73.68,14.59.77-6.62-3.21-40.92-4.08-44.64-1.21Z"
                    ></path>
                  </svg>
                  <TextIconsP>{t("PRODUCT.FLAVOR")}</TextIconsP>
                  <h3>{product.flavor}</h3>
                </GridIconsItem>

                <GridIconsItem>
                  {" "}
                  <svg
                    height="60"
                    width="60"
                    version="1.1"
                    id="Capa_1"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 339.622 339.622"
                  >
                    <g>
                      <g>
                        <path
                          fill="var(--accent-200)"
                          d="M108.4,122.822c23.313,0,44.716,8.318,61.411,22.131c16.695-13.819,38.098-22.131,61.411-22.131
			c7.411,0,14.601,0.919,21.534,2.512c0.095-1.665,0.251-3.312,0.251-4.994c0-46.613-37.919-84.533-84.533-84.533
			S83.942,73.727,83.942,120.34c0,1.915,0.161,3.789,0.286,5.674C91.967,124.003,100.041,122.822,108.4,122.822z M168.469,47.741
			c36.977,0,67.587,27.788,72.038,63.577c-3.121-0.28-6.223-0.424-9.296-0.424c-21.94,0-43.409,6.737-61.411,19.124
			c-17.996-12.387-39.465-19.124-61.411-19.124c-3.962,0-7.966,0.239-11.999,0.71C100.727,75.672,131.396,47.741,168.469,47.741z"
                        />
                        <path
                          fill="var(--accent-200)"
                          d="M191.059,201.71c-3.276-15.424-10.806-29.262-21.254-40.336
			c-10.591,11.23-18.211,25.294-21.415,40.98c6.45,1.581,13.151,2.512,20.079,2.512C176.303,204.866,183.857,203.715,191.059,201.71
			z M169.799,180.725c2.375,3.753,4.398,7.703,6.044,11.808c-2.47,0.269-4.929,0.4-7.375,0.4c-1.587,0-3.186-0.06-4.809-0.173
			C165.324,188.577,167.377,184.549,169.799,180.725z"
                        />
                        <path
                          fill="var(--accent-200)"
                          d="M85.81,137.912c5.889,27.728,25.419,50.432,51.202,60.814c3.789-17.364,12.286-32.949,24.052-45.45
			c-14.464-11.564-32.752-18.527-52.67-18.527C100.566,134.756,93.012,135.907,85.81,137.912z M129.642,181.602
			c-12.972-8.204-22.996-20.275-28.641-34.506c2.482-0.268,4.947-0.4,7.393-0.4c12.471,0,24.416,3.121,35.115,9.105
			C137.727,163.761,133.061,172.437,129.642,181.602z"
                        />
                        <path
                          fill="var(--accent-200)"
                          d="M262.68,140.896c-6.85,31.41-29.035,57.115-58.302,68.905c0.304,3.127,0.483,6.289,0.483,9.493
			c0,25.538-10.048,48.731-26.308,66.005c14.464,11.564,32.752,18.521,52.664,18.521c46.613,0,84.533-37.914,84.533-84.527
			C315.749,183.803,293.743,153.408,262.68,140.896z M231.216,291.881c-12.465,0-24.41-3.115-35.109-9.099
			c13.419-18.438,20.687-40.527,20.687-63.493c0-0.656-0.006-1.325-0.018-1.993c24.751-12.345,43.755-33.57,53.296-59.281
			c20.842,13.157,33.743,36.022,33.743,61.274C303.815,259.314,271.248,291.881,231.216,291.881z"
                        />
                        <path
                          fill="var(--accent-200)"
                          d="M276.863,121.104c0.006-0.257,0.006-0.513,0.006-0.764c0-59.77-48.624-108.4-108.4-108.4
			c-59.77,0-108.4,48.63-108.4,108.4c0,0.656,0.006,1.319,0.018,1.987C23.319,140.603,0,177.783,0,219.288
			c0,59.77,48.624,108.394,108.4,108.394c21.946,0,43.415-6.737,61.411-19.124c17.996,12.387,39.465,19.124,61.411,19.124
			c59.776,0,108.4-48.624,108.4-108.394C339.616,177.174,314.734,138.771,276.863,121.104z M231.216,315.749
			c-23.313,0-44.716-8.318-61.411-22.131c-16.695,13.813-38.098,22.131-61.411,22.131c-53.189,0-96.46-43.272-96.46-96.46
			c0-40.491,25.115-75.183,60.552-89.461c-0.304-3.127-0.483-6.289-0.483-9.493c0-53.195,43.272-96.466,96.466-96.466
			s96.466,43.272,96.466,96.466c0,2.876-0.185,5.716-0.43,8.527c36.81,13.598,63.177,48.946,63.177,90.422
			C327.683,272.477,284.405,315.749,231.216,315.749z"
                        />
                        <path
                          fill="var(--accent-200)"
                          d="M192.64,213.614c-7.739,2.005-15.812,3.186-24.172,3.186c-7.411,0-14.595-0.919-21.528-2.506
			c-0.095,1.665-0.251,3.312-0.251,4.994c0,22.418,8.831,42.765,23.122,57.908c14.291-15.144,23.122-35.491,23.122-57.908
			C192.927,217.373,192.766,215.499,192.64,213.614z M169.805,257.84c-5.669-8.962-9.296-19.022-10.621-29.53
			c3.121,0.286,6.223,0.424,9.284,0.424c3.95,0,7.96-0.239,11.993-0.71C179.167,238.639,175.533,248.795,169.805,257.84z"
                        />
                        <path
                          fill="var(--accent-200)"
                          d="M135.185,210.756c-30.228-11.164-53.35-36.989-60.665-68.864
			c-29.781,13.091-50.653,42.836-50.653,77.396c0,46.613,37.919,84.527,84.533,84.527c19.911,0,38.206-6.963,52.664-18.521
			c-16.26-17.274-26.308-40.461-26.308-66.006C134.75,216.406,134.935,213.572,135.185,210.756z M143.503,282.782
			c-10.699,5.985-22.638,9.099-35.109,9.099c-40.026,0-72.593-32.567-72.593-72.593c0-24.184,12.077-46.476,31.636-59.866
			c10.06,26.063,29.81,47.234,55.384,59.108c0,0.251,0,0.507,0,0.758C122.816,242.249,130.084,264.344,143.503,282.782z"
                        />
                        <path
                          fill="var(--accent-200)"
                          d="M251.295,137.268c-6.45-1.581-13.151-2.512-20.079-2.512c-19.911,0-38.206,6.963-52.664,18.527
			c11.54,12.256,19.905,27.489,23.796,44.447C227.135,186.835,245.751,164.417,251.295,137.268z M231.216,146.69
			c1.593,0,3.204,0.06,4.833,0.179c-5.322,13.491-14.619,25.121-26.636,33.343c-3.359-8.652-7.834-16.868-13.312-24.41
			C206.8,149.81,218.745,146.69,231.216,146.69z"
                        />
                      </g>
                    </g>
                  </svg>
                  <TextIconsP>{t("PRODUCT.STRENGTH_LABEL")}</TextIconsP>
                  <h3>
                    {product.nicotine < 6
                      ? t("PRODUCT.STRENGTH.MILD")
                      : product.nicotine > 14
                      ? t("PRODUCT.STRENGTH.STRONG")
                      : t("PRODUCT.STRENGTH.REGULAR")}
                  </h3>
                </GridIconsItem>
                <GridIconsItem>
                  {" "}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="60"
                    height="60"
                    viewBox="0 0 50 24"
                    fill="none"
                    class="w-12 h-12 hover:text-black"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M47.2451 20.6032C47.2451 21.0134 47.0719 21.3899 46.7551 21.6634C46.6049 21.7956 46.427 21.8951 46.2334 21.9549C46.0399 22.0147 45.8353 22.0336 45.6336 22.0102C44.0548 21.8397 42.4525 21.6931 40.8379 21.5603V15.441C40.8379 15.1782 40.7299 14.9262 40.5376 14.7404C40.3454 14.5545 40.0846 14.4501 39.8127 14.4501C39.5408 14.4501 39.2801 14.5545 39.0878 14.7404C38.8956 14.9262 38.7876 15.1782 38.7876 15.441V21.4176C34.0967 21.0867 29.395 20.9198 24.6917 20.9173C17.4951 20.9173 10.4492 21.2849 3.74975 22.0102C3.54802 22.0333 3.3435 22.0144 3.15001 21.9545C2.95652 21.8947 2.77859 21.7954 2.62823 21.6634C2.4727 21.5307 2.34846 21.3673 2.26392 21.1842C2.17938 21.0012 2.13651 20.8027 2.13821 20.6022V3.39647C2.13821 2.98626 2.31146 2.60975 2.62823 2.33628C2.77877 2.20452 2.95673 2.1054 3.15017 2.04559C3.3436 1.98578 3.54804 1.96665 3.74975 1.98949C5.36745 2.16487 7.00873 2.31646 8.66436 2.45023V8.3625C8.66436 8.62528 8.77236 8.8773 8.96462 9.06312C9.15687 9.24894 9.41762 9.35332 9.68951 9.35332C9.9614 9.35332 10.2222 9.24894 10.4144 9.06312C10.6067 8.8773 10.7147 8.62528 10.7147 8.3625V2.58993C15.2746 2.907 19.9452 3.08237 24.6917 3.08237C31.8883 3.08237 38.9342 2.71577 45.6336 1.98949C46.0508 1.94986 46.4455 2.06876 46.7551 2.33628C47.0719 2.60975 47.2451 2.98626 47.2451 3.39647V20.6032ZM48.1216 0.859946C47.7555 0.543386 47.3243 0.305021 46.8564 0.160412C46.3885 0.0158032 45.8943 -0.0317983 45.406 0.0207151C38.7814 0.737084 31.8124 1.10072 24.6917 1.10072C17.5709 1.10072 10.6019 0.737084 3.97734 0.0207151C3.48909 -0.0315467 2.99493 0.0161746 2.52703 0.160772C2.05914 0.305368 1.628 0.543598 1.2617 0.859946C0.892446 1.17915 0.597037 1.57007 0.394771 2.00716C0.192505 2.44424 0.0879336 2.91766 0.0878906 3.39647V20.6032C0.0878906 21.5712 0.515381 22.4957 1.2617 23.1397C1.62782 23.4563 2.05894 23.6947 2.52688 23.8393C2.99483 23.9839 3.48907 24.0315 3.97734 23.9789C10.6019 23.2626 17.5709 22.8989 24.6917 22.8989C31.8124 22.8989 38.7814 23.2626 45.406 23.9789C45.8943 24.032 46.3886 23.9846 46.8567 23.84C47.3247 23.6953 47.7558 23.4567 48.1216 23.1397C48.4909 22.8205 48.7863 22.4296 48.9886 21.9925C49.1908 21.5554 49.2954 21.082 49.2954 20.6032V3.39647C49.2954 2.42843 48.8679 1.50398 48.1216 0.859946Z"
                      fill="var(--accent-200)"
                    ></path>
                  </svg>
                  <TextIconsP>{t("PRODUCT.FORMAT")}</TextIconsP>
                  <h3>{product.format}</h3>
                </GridIconsItem>
              </GridIcons>

              <GridQuantity>
                {[1, 10, 30, 50].map((quantity, index) => {
                  const { discountedPrice, savings } =
                    getDiscountData(quantity); // Calculate discount for each quantity

                  return (
                    <GridQuantityItem
                      key={index}
                      $isActive={selectedQuantity === quantity}
                      onClick={() => setSelectedQuantity(quantity)}
                    >
                      <QuantityLabel>{quantity}x</QuantityLabel>
                      <QuantityPiecePrice>
                        {currencyTag}
                        {discountedPrice.toFixed(2)}/{t("PRODUCT_CARD.PIECE")}
                      </QuantityPiecePrice>
                      {savings > 0 && (
                        <QuantityBadge>-{savings}%</QuantityBadge>
                      )}
                    </GridQuantityItem>
                  );
                })}
              </GridQuantity>

              <FlexDivPrice style={{ width: "100%" }}>
                <div>
                  <h3 style={{ color: "var(--accent-200)" }}>
                    {currencyTag}
                    {discountedPrice.toFixed(2)}/{t("PRODUCT_CARD.PIECE")}
                  </h3>
                  <h4>
                    <span style={{ marginRight: "4px" }}>MSRP</span>
                    {currencyTag}
                    {product.price}
                  </h4>
                </div>
                <div
                  style={{
                    textAlign: "right",
                    whiteSpace: "nowrap",
                    height: "50px",
                  }}
                >
                  <Price style={{ fontWeight: 100 }}>
                    {currencyTag}
                    {(discountedPrice * selectedQuantity).toFixed(2)}
                  </Price>
                  {selectedQuantity !== 1 && (
                    <h4
                      style={{
                        fontWeight: 100,
                        textDecoration: "line-through",
                      }}
                    >
                      {currencyTag}
                      {(product.price * selectedQuantity).toFixed(2)}
                    </h4>
                  )}
                </div>
              </FlexDivPrice>

              <ButtonContainer ref={buyBoxRef}>
                <ButtonWrapper>
                  <Button
                    onClick={() => addToCart(selectedQuantity)}
                    disabled={product.is_in_stock === "out_of_stock"}
                  >
                    {product.is_in_stock !== "out_of_stock"
                      ? t("BUTTONS.ADD_TO_CART")
                      : t("BUTTONS.AVAILABLE_SOON") + "!"}
                  </Button>

                  {isAnimating && (
                    <AddToCartAnim
                      isAnimating={isAnimating}
                      onComplete={handleAnimationComplete}
                    />
                  )}
                </ButtonWrapper>
              </ButtonContainer>

              <div
                style={{
                  backgroundColor: "var(--bg-200)",
                  padding: "14px",
                  borderRadius: "6px",
                  order: "4",
                }}
              >
                <DescText>{shortDesc}</DescText>

                <BrT />

                <FlexDivIcons>
                  <IconDiv>
                    <SVGIcon
                      fill="var(--accent-200)"
                      height="32"
                      width="32"
                      version="1.1"
                      id="Layer_1"
                      viewBox="0 0 512.001 512.001"
                    >
                      <g>
                        <g>
                          <g>
                            <path
                              d="M466.395,88.411C395.95,69.109,325.091,39.054,261.478,1.496c-3.379-1.995-7.572-1.995-10.95,0
				C185.08,40.133,118.05,68.562,45.605,88.411c-4.68,1.281-7.924,5.535-7.924,10.388v110.046
				c0,113.323,52.279,188.335,96.137,231.306c47.216,46.265,102.216,71.85,122.185,71.85c19.967,0,74.967-25.585,122.183-71.85
				c43.857-42.97,96.133-117.982,96.133-231.306V98.798C474.319,93.946,471.075,89.692,466.395,88.411z M452.779,208.844
				c0,105.843-48.761,175.838-89.669,215.92c-46.431,45.495-96.074,65.695-107.107,65.695c-11.033,0-60.679-20.2-107.111-65.695
				c-40.907-40.083-89.67-110.077-89.67-215.92V106.974C128.5,87.304,193.018,59.853,256.005,23.25
				c61.414,35.632,129.151,64.448,196.774,83.72V208.844z"
                            />
                            <path
                              d="M160.538,105.769c-2.18-5.535-8.433-8.254-13.969-6.073c-19.24,7.581-38.988,14.559-58.695,20.741
				c-4.491,1.41-7.547,5.57-7.547,10.276v41.591c0,5.948,4.823,10.77,10.77,10.77s10.77-4.822,10.77-10.77v-33.72
				c17.679-5.72,35.339-12.047,52.598-18.848C160,117.557,162.719,111.304,160.538,105.769z"
                            />
                            <path
                              d="M180.997,107.812c1.445,0,2.912-0.291,4.319-0.905l0.198-0.086c5.449-2.388,7.903-8.731,5.515-14.178
				c-2.39-5.449-8.769-7.914-14.212-5.528l-0.174,0.075c-5.452,2.381-7.914,8.719-5.533,14.169
				C172.877,105.405,176.842,107.812,180.997,107.812z"
                            />
                            <path
                              d="M384.322,347.283c-4.977-3.253-11.651-1.854-14.908,3.125c-8.875,13.584-19.287,26.592-30.951,38.659
				c-9.592,9.922-19.986,19.17-30.893,27.485c-4.729,3.606-5.639,10.364-2.034,15.095c2.121,2.779,5.328,4.241,8.572,4.241
				c2.278,0,4.573-0.719,6.523-2.207c11.765-8.971,22.975-18.944,33.317-29.642c12.611-13.044,23.881-27.124,33.499-41.849
				C390.702,357.21,389.301,350.536,384.322,347.283z"
                            />
                            <path
                              d="M282.558,433.443l-0.618,0.364c-5.147,2.981-6.906,9.569-3.926,14.716c1.997,3.45,5.612,5.376,9.331,5.376
				c1.83,0,3.688-0.467,5.385-1.452l0.713-0.419c5.133-3.006,6.857-9.603,3.851-14.736
				C294.286,432.161,287.688,430.44,282.558,433.443z"
                            />
                            <path
                              d="M182.589,234.019c-6.613-6.614-15.408-10.254-24.762-10.254s-18.15,3.641-24.766,10.254
				c-13.653,13.656-13.653,35.876,0,49.531l63.596,63.594c6.614,6.612,15.409,10.253,24.764,10.253s18.15-3.641,24.765-10.255
				L378.947,214.38c13.652-13.659,13.652-35.876-0.002-49.527c-6.614-6.614-15.409-10.254-24.765-10.254
				c-9.355,0-18.15,3.641-24.765,10.254L221.42,272.848L182.589,234.019z M344.647,180.085c2.545-2.545,5.932-3.946,9.534-3.946
				c3.604,0,6.988,1.401,9.535,3.946c5.255,5.255,5.255,13.809-0.002,19.066l-132.759,132.76c-2.545,2.545-5.932,3.946-9.534,3.946
				s-6.989-1.401-9.535-3.946l-63.594-63.592c-5.257-5.257-5.257-13.811-0.002-19.066c2.546-2.545,5.933-3.948,9.536-3.948
				s6.988,1.401,9.533,3.946l46.445,46.446c2.021,2.019,4.759,3.154,7.616,3.154s5.595-1.134,7.614-3.154L344.647,180.085z"
                            />
                          </g>
                        </g>
                      </g>
                    </SVGIcon>
                    <IconText>{t("PRODUCT.SECURE_PAYMENTS")}</IconText>
                  </IconDiv>
                  <IconDiv>
                    <SVGIcon
                      width="32"
                      height="32"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M14.7667 2.50445L14.1843 2.84068H10.3906C10.1835 2.84068 10.0156 3.00859 10.0156 3.21568C10.0156 3.42278 10.1835 3.59068 10.3906 3.59068H12.8853L12.1697 4.00379L20.5891 8.86478V12.4667C20.5891 12.6107 20.5178 12.7343 20.3931 12.8063L18.4415 13.933C18.3792 13.969 18.3078 13.969 18.2455 13.933C18.1831 13.897 18.1475 13.8352 18.1475 13.7633V10.2744L9.72816 5.41342L7.34442 6.78967C7.30214 6.77312 7.25616 6.76407 7.20802 6.76407H0.796922C0.589828 6.76407 0.421922 6.93198 0.421922 7.13907C0.421922 7.34617 0.589828 7.51407 0.796922 7.51407H6.74278C6.74044 7.53957 6.73922 7.5655 6.73922 7.59175V11.6251H3.02902C2.82192 11.6251 2.65402 11.793 2.65402 12.0001C2.65402 12.2072 2.82192 12.3751 3.02902 12.3751H6.73922V16.0172H0.796875C0.589781 16.0172 0.421875 16.1852 0.421875 16.3922C0.421875 16.5993 0.589781 16.7672 0.796875 16.7672H6.82294C6.88955 16.8982 6.99431 17.0083 7.13123 17.0874L14.7667 21.4957C15.016 21.6397 15.3014 21.6397 15.5507 21.4957L23.1861 17.0874C23.4354 16.9435 23.5781 16.6963 23.5781 16.4084V7.59175C23.5781 7.30389 23.4354 7.05671 23.1861 6.91276L15.5506 2.50445C15.3014 2.3605 15.016 2.3605 14.7667 2.50445ZM7.57317 2.84064C7.78027 2.84064 7.94817 3.00854 7.94817 3.21564C7.94817 3.42273 7.78027 3.59064 7.57317 3.59064H2.56031C2.35322 3.59064 2.18531 3.42273 2.18531 3.21564C2.18531 3.00854 2.35322 2.84064 2.56031 2.84064H7.57317Z"
                        fill="var(--accent-200)"
                      />
                    </SVGIcon>
                    <IconText>{t("PRODUCT.LOWEST_PRICE")}</IconText>
                  </IconDiv>
                  <IconDiv>
                    <SVGIcon
                      width="32"
                      height="32"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M22.6985 14.4272H23.4375V12.1919C23.4375 12.0767 23.4173 11.9782 23.3717 11.8708L21.8297 8.2401C21.6816 7.89135 21.3323 7.67291 20.9226 7.67291H17.3768V17.2668H17.7274C17.7274 15.9941 18.7595 14.962 20.0321 14.962C21.3048 14.962 22.3369 15.9942 22.3369 17.2668H22.8544C23.1755 17.2668 23.4374 17.0049 23.4374 16.6837V15.8832H22.6984C22.5504 15.8832 22.4296 15.7625 22.4296 15.6144V14.6959C22.4297 14.5479 22.5504 14.4272 22.6985 14.4272ZM17.8218 11.9016V8.86789H20.7981L22.0865 11.9016H17.8218ZM15.8495 5.17822C11.4575 5.17822 7.06552 5.17822 2.67356 5.17822C2.46647 5.17822 2.29856 5.34613 2.29856 5.55322C2.29856 5.76032 2.46647 5.92822 2.67356 5.92822H4.75181C5.11598 5.92822 5.41392 6.22616 5.41392 6.59033C5.41392 6.9545 5.11598 7.25244 4.75181 7.25244H1.4393H0.9375C0.730406 7.25244 0.5625 7.42035 0.5625 7.62744C0.5625 7.83453 0.730406 8.00244 0.9375 8.00244H4.15823C4.52241 8.00244 4.82034 8.30038 4.82034 8.66455C4.82034 9.02872 4.52241 9.32666 4.15823 9.32666H1.99303C1.78594 9.32666 1.61803 9.49457 1.61803 9.70166C1.61803 9.90875 1.78594 10.0767 1.99303 10.0767H5.10694C5.47111 10.0767 5.76905 10.3746 5.76905 10.7388C5.76905 11.1029 5.47111 11.4009 5.10694 11.4009C3.71714 11.4009 2.3273 11.4008 0.9375 11.4009C0.730406 11.4009 0.5625 11.5688 0.5625 11.7759C0.5625 11.983 0.730406 12.1509 0.9375 12.1509H4.15823V16.4895C4.15823 16.9176 4.50745 17.2669 4.93561 17.2669H6.54398C6.54398 15.9942 7.57612 14.9621 8.84873 14.9621C10.1214 14.9621 11.1535 15.9942 11.1535 17.2669H16.6268V5.9556C16.6268 5.52744 16.2776 5.17822 15.8495 5.17822ZM10.7812 14.2861C9.00075 14.2861 7.55742 12.8428 7.55742 11.0623C7.55742 9.28189 9.00075 7.83857 10.7812 7.83857C12.5617 7.83857 14.005 9.28189 14.005 11.0623C14.005 12.8428 12.5617 14.2861 10.7812 14.2861ZM10.3578 11.3467L11.9253 9.76349C12.1109 9.57608 12.4136 9.57557 12.6005 9.76138C12.7873 9.94714 12.7879 10.249 12.6025 10.4361C11.9669 11.0776 11.3355 11.7234 10.6969 12.3621C10.5102 12.5488 10.2074 12.5488 10.0207 12.3621L8.96124 11.3026C8.77453 11.1159 8.77453 10.8131 8.96124 10.6264C9.14794 10.4397 9.45075 10.4397 9.63745 10.6264L10.3578 11.3467ZM8.84878 15.712C7.99008 15.712 7.29403 16.4081 7.29403 17.2668C7.29403 18.1255 7.99013 18.8216 8.84878 18.8216C9.70748 18.8216 10.4036 18.1255 10.4036 17.2668C10.4036 16.4081 9.70748 15.712 8.84878 15.712ZM8.84878 17.7965C8.556 17.7965 8.31905 17.5596 8.31905 17.2668C8.31905 16.974 8.556 16.7371 8.84878 16.7371C9.14156 16.7371 9.37852 16.974 9.37852 17.2668C9.37852 17.5596 9.14156 17.7965 8.84878 17.7965ZM20.0322 15.712C19.1735 15.712 18.4774 16.4081 18.4774 17.2668C18.4774 18.1255 19.1735 18.8216 20.0322 18.8216C20.8909 18.8216 21.5869 18.1255 21.5869 17.2668C21.587 16.4081 20.8909 15.712 20.0322 15.712ZM20.0322 17.7965C19.7394 17.7965 19.5024 17.5596 19.5024 17.2668C19.5024 16.974 19.7394 16.7371 20.0322 16.7371C20.325 16.7371 20.5619 16.974 20.5619 17.2668C20.5619 17.5596 20.325 17.7965 20.0322 17.7965Z"
                        fill="var(--accent-200)"
                      />
                    </SVGIcon>
                    <IconText>{t("PRODUCT.SATISFACTION_GUARANTEED")}</IconText>
                  </IconDiv>
                </FlexDivIcons>
              </div>

              <BrT />
            </RightContainer>
            <SpecificationMobile>
              <ProductDetails product={product} />
            </SpecificationMobile>
          </Wrapper>

          <StickyBar $visible={showStickyBar}>
            <StickyBarPrice>
              <strong>
                {currencyTag}
                {(discountedPrice * selectedQuantity).toFixed(2)}
              </strong>
              <span>
                {selectedQuantity}x {currencyTag}
                {discountedPrice.toFixed(2)}/{t("PRODUCT_CARD.PIECE")}
              </span>
            </StickyBarPrice>
            <StickyBarButton
              onClick={() => addToCart(selectedQuantity)}
              disabled={product.is_in_stock === "out_of_stock"}
            >
              {product.is_in_stock !== "out_of_stock"
                ? t("BUTTONS.ADD_TO_CART")
                : t("BUTTONS.AVAILABLE_SOON") + "!"}
            </StickyBarButton>
          </StickyBar>
        </>
      )}
    </Container>
  );
};

export default ProductMain;
